var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRmlogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1640,
    height: 830,
    viewBox: "0 775 1640 830",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.123969,0,0,3.123969,-1608.276715,-2646.663307)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ff385c",
    d: "M571.138,1098.999L700.09,1098.999C700.09,1098.999 738.72,1101.076 763.562,1134.152C788.974,1167.989 752.238,1196.513 736.659,1203.515C720.521,1210.767 695.458,1218.534 695.458,1218.534L724.146,1239.797L829.062,1130.996L895.225,1133.348L887.658,1194.831L956.663,1134.136L1034.2,1134.136L961.111,1357.135L881.514,1357.135L914.663,1257.525L844.013,1325.486L813.567,1304.229L816.062,1251.353L715.222,1356.529L621.785,1355.979L678.44,1291.489L619.908,1246.889L633.182,1177.86L658.394,1177.325C658.394,1177.325 672.389,1176.512 673.231,1167.679C673.982,1159.805 658.808,1159.09 650.907,1158.355C643.007,1157.62 633.379,1157.546 633.379,1157.546L593.512,1356.691L518.932,1355.979L571.138,1098.999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRmlogo);
export default __webpack_public_path__ + "static/media/rmlogo.a9bc337cc0eab2747035ad7b36481473.svg";
export { ForwardRef as ReactComponent };